export const outlookTypes = {
  NONE: 'none',
  STABLE: 'stable',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
};

export const outlookLabels = {
  [undefined]: 'N/A',
  [null]: 'N/A',
  [outlookTypes.NONE]: 'none',
  [outlookTypes.STABLE]: 'stable',
  [outlookTypes.NEGATIVE]: 'negative',
  [outlookTypes.POSITIVE]: 'positive',
};
